import { AboutSubnav, AboutHero } from "../../components/AboutLayout";
import Reveal from "../../components/Reveal";
import { TIMELINE } from "../../lib/data";

export default function Timeline() {
  return (
    <div data-testid="about-timeline" className="grain bg-[#f7f7f5]">
      <AboutSubnav />
      <AboutHero
        kicker="/ Timeline · Five Decades"
        title="Milestones in"
        accent=" molten steel."
        subtitle="From the shutters opening in 1969 to a four-branch network — every milestone tells a story of trust, persistence, and family."
      />

      <section className="bg-white py-24">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div className="relative">
            <div className="absolute left-[10px] top-0 h-full w-px bg-black/10 md:left-1/2" />
            <div className="space-y-14">
              {TIMELINE.map((t, i) => (
                <Reveal
                  key={`${t.year}-${i}`}
                  delay={Math.min(i * 40, 320)}
                  data-testid={`timeline-${t.year}-${i}`}
                  className="relative grid gap-6 md:grid-cols-2"
                >
                  <div
                    className={`${
                      i % 2 === 0 ? "md:pr-16 md:text-right" : "md:order-2 md:pl-16"
                    } pl-10 md:pl-0`}
                  >
                    <div className="font-display text-4xl tracking-tighter text-[#e85a1c] md:text-6xl">
                      {t.year}
                    </div>
                    <div className="mt-1 font-display-med text-xl uppercase tracking-tight text-[#1c1c1e] md:text-2xl">
                      {t.title}
                    </div>
                    <p className="mt-3 text-sm leading-relaxed text-[#4a4a4e] md:text-base">
                      {t.text}
                    </p>
                  </div>
                  <div className="absolute left-[2px] top-2 h-5 w-5 rounded-full border-2 border-[#e85a1c] bg-white shadow-lux md:left-1/2 md:-translate-x-1/2" />
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
